import React from 'react';
import {RouteHandler} from 'react-router';

class BsnTemplate extends React.Component {

    render() {
        return (
            <RouteHandler {...this.props} />
        )
    }
}


export default BsnTemplate;



/** WEBPACK FOOTER **
 ** ./app/src/views/BsnTemplate.js
 **/